/** Keep in sync with apps/api/src/lib/receiptFiles.ts */
export const MAX_RECEIPT_FILE_BYTES = 12 * 1024 * 1024;

export function receiptFileError(file: File): string | null {
  if (file.size > MAX_RECEIPT_FILE_BYTES) {
    return `${file.name} is too large (max 12 MB per file)`;
  }

  const type = file.type.trim().toLowerCase();
  const name = file.name.trim().toLowerCase();

  if (
    type.startsWith("image/") ||
    type === "application/pdf" ||
    type === "application/x-pdf" ||
    type === "application/octet-stream" ||
    type === ""
  ) {
    if (
      type === "application/octet-stream" ||
      type === "" ||
      type === "application/x-pdf"
    ) {
      const extOk =
        name.endsWith(".pdf") ||
        name.endsWith(".jpg") ||
        name.endsWith(".jpeg") ||
        name.endsWith(".png") ||
        name.endsWith(".webp") ||
        name.endsWith(".heic") ||
        name.endsWith(".heif");
      if (!extOk) return `${file.name} must be a JPEG, PNG, WebP, HEIC, or PDF`;
    }
    return null;
  }

  return `${file.name} must be a photo or PDF`;
}
